// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"styles__fadeIn__p-Sk7","dashdraw":"styles__dashdraw__0kXcg","spin":"styles__spin__zG2BU"};